/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  UtxDataWarehouseGetAssetBalanceSummaryParams
} from './schema'



/**
 * Retrieve asset balance over time
 */
export const utxDataWarehouseGetUserBalanceOvertime = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/balance-over-time`,options
    );
  }


export const getUtxDataWarehouseGetUserBalanceOvertimeQueryKey = () => [`/balance-over-time`];

    
export type UtxDataWarehouseGetUserBalanceOvertimeQueryResult = NonNullable<Awaited<ReturnType<typeof utxDataWarehouseGetUserBalanceOvertime>>>
export type UtxDataWarehouseGetUserBalanceOvertimeQueryError = AxiosError<unknown>

export const useUtxDataWarehouseGetUserBalanceOvertime = <TData = Awaited<ReturnType<typeof utxDataWarehouseGetUserBalanceOvertime>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxDataWarehouseGetUserBalanceOvertime>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxDataWarehouseGetUserBalanceOvertimeQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxDataWarehouseGetUserBalanceOvertime>>> = ({ signal }) => utxDataWarehouseGetUserBalanceOvertime({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxDataWarehouseGetUserBalanceOvertime>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Retrieve asset balance summary
 */
export const utxDataWarehouseGetAssetBalanceSummary = (
    params?: UtxDataWarehouseGetAssetBalanceSummaryParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/balance-over-time/summary`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxDataWarehouseGetAssetBalanceSummaryQueryKey = (params?: UtxDataWarehouseGetAssetBalanceSummaryParams,) => [`/balance-over-time/summary`, ...(params ? [params]: [])];

    
export type UtxDataWarehouseGetAssetBalanceSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof utxDataWarehouseGetAssetBalanceSummary>>>
export type UtxDataWarehouseGetAssetBalanceSummaryQueryError = AxiosError<unknown>

export const useUtxDataWarehouseGetAssetBalanceSummary = <TData = Awaited<ReturnType<typeof utxDataWarehouseGetAssetBalanceSummary>>, TError = AxiosError<unknown>>(
 params?: UtxDataWarehouseGetAssetBalanceSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxDataWarehouseGetAssetBalanceSummary>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxDataWarehouseGetAssetBalanceSummaryQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxDataWarehouseGetAssetBalanceSummary>>> = ({ signal }) => utxDataWarehouseGetAssetBalanceSummary(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxDataWarehouseGetAssetBalanceSummary>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

